import { MessageCircle, Phone } from "lucide-react";
import { SITE, viberHref, whatsappHref } from "../config/site";
import { trackContact } from "../lib/pixel";
import { useI18n } from "../i18n";

export function CallButton({ className = "btn", label, source = "sajt", children, ...rest }) {
  const { t } = useI18n();
  return (
    <a
      href={SITE.phoneHref}
      className={className}
      onClick={() => trackContact("Poziv", { source })}
      {...rest}
    >
      <Phone size={18} aria-hidden="true" />
      {children || label || `${t("common.call")}: ${SITE.phoneDisplay}`}
    </a>
  );
}

export function EmailLink({ className, source = "sajt", children }) {
  return (
    <a href={`mailto:${SITE.email}`} className={className} onClick={() => trackContact("Email", { source })}>
      {children || SITE.email}
    </a>
  );
}

// Viber / WhatsApp buttons, shown only when enabled in config/site.js
export function MessengerButtons({ text = "", source = "sajt", className = "btn btn--ghost" }) {
  const { viber, whatsapp } = SITE.messengers;
  if (!viber && !whatsapp) return null;
  return (
    <>
      {viber && (
        <a href={viberHref} className={className} onClick={() => trackContact("Viber", { source })}>
          <MessageCircle size={18} aria-hidden="true" /> Viber
        </a>
      )}
      {whatsapp && (
        <a
          href={whatsappHref(text)}
          className={className}
          target="_blank"
          rel="noreferrer"
          onClick={() => trackContact("WhatsApp", { source })}
        >
          <MessageCircle size={18} aria-hidden="true" /> WhatsApp
        </a>
      )}
    </>
  );
}
